'use client';
import { useTranslations } from 'next-intl';
import { type FAQ, FAQJsonLd } from '@/app/components/shared/json-ld';
import { SITE } from '@/app/constants';
import { useLocale, usePathname } from '@/i18n/routing';
import { FAQ_SEO_CONFIG } from './constants';

export function LayoutFAQJsonLd() {
  const locale = useLocale();
  const pathname = usePathname();
  const t = useTranslations('home3.questions');

  // 判断是否为首页
  const isHomePage = pathname === '/';

  // 如果不是全球站点或不是首页，则不渲染
  if (SITE === 'china' || !isHomePage) {
    return null;
  }

  const faqs: FAQ[] =
    FAQ_SEO_CONFIG(t)?.[SITE][locale]?.map((faq) => ({
      question: faq.question,
      answer: faq.answer,
    })) || [];

  return <FAQJsonLd faqs={faqs} />;
}
